module.exports = __webpack_public_path__ + "static/media/nginx.24142e2e.svg";